import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, TextField, InputAdornment } from '@mui/material';
import { NfcomItem } from './EmitirNfcomModal';
import { formatarValorOnInput } from '../../utils/formatToView';

interface AdicionarItemNfcomModalProps {
  open: boolean;
  onClose: () => void;
  onAdd: (item: NfcomItem) => void;
}

const AdicionarItemNfcomModal: React.FC<AdicionarItemNfcomModalProps> = ({ open, onClose, onAdd }) => {
  const [descricao, setDescricao] = useState('');
  const [quantidade, setQuantidade] = useState<number>(1);
  const [valorUnitario, setValorUnitario] = useState<number>(0);
  const [desconto, setDesconto] = useState<number>(0);
  const [valorUnitarioFormatado, setValorUnitarioFormatado] = useState<string>('0,00');
  const [descontoFormatado, setDescontoFormatado] = useState<string>('0,00');

  const parsearMoeda = (valorFormatado: string): number => {
    const numeroLimpo = (valorFormatado || '').toString().replace(/[^\d,]/g, '');
    const numeroComPonto = numeroLimpo.replace(',', '.');
    const numero = parseFloat(numeroComPonto) || 0;
    return numero;
  };

  const resetFields = () => {
    setDescricao('');
    setQuantidade(1);
    setValorUnitario(0);
    setDesconto(0);
    setValorUnitarioFormatado('0,00');
    setDescontoFormatado('0,00');
  };

  // Não limpar ao abrir; apenas ao fechar ou após adicionar

  const handleAdd = () => {
    const total = quantidade * valorUnitario - desconto;
    onAdd({
      descricao,
      quantidade,
      valor_unitario: valorUnitario,
      desconto,
      valor_total: total < 0 ? 0 : Number(total.toFixed(2)),
      valor_unitario_formatado: valorUnitarioFormatado,
      desconto_formatado: descontoFormatado,
      valor_total_formatado: formatarValorOnInput(String((total < 0 ? 0 : Number(total.toFixed(2))).toFixed(2).replace('.', ',')))
    });
    resetFields();
    onClose();
  };

  const handleClose = () => {
    resetFields();
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Adicionar Item</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={12}>
            <TextField label="Descrição" value={descricao} onChange={(e) => setDescricao(e.target.value)} fullWidth size="small" />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField type="number" label="Quantidade" value={quantidade} onChange={(e) => setQuantidade(Number(e.target.value))} fullWidth size="small" />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField 
              label="Valor Unit." 
              value={valorUnitarioFormatado}
              onChange={(e) => {
                const masked = formatarValorOnInput(e.target.value);
                setValorUnitarioFormatado(masked);
                setValorUnitario(parsearMoeda(masked));
              }} 
              fullWidth 
              size="small" 
              InputProps={{ startAdornment: <InputAdornment position="start">R$</InputAdornment> }}
            />
          </Grid>
          <Grid item xs={12} sm={5}>
            <TextField 
              label="Desconto" 
              value={descontoFormatado}
              onChange={(e) => {
                const masked = formatarValorOnInput(e.target.value);
                setDescontoFormatado(masked);
                setDesconto(parsearMoeda(masked));
              }} 
              fullWidth 
              size="small" 
              InputProps={{ startAdornment: <InputAdornment position="start">R$</InputAdornment> }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button variant="contained" onClick={handleAdd} disabled={!descricao}>Adicionar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AdicionarItemNfcomModal;
